<h3 *ngIf="title" class="shops-title">{{ title }}</h3>
<div class="shops-container">
  @for (shop of shops; track shop._id; let i = $index) {
    <div
      [reactComponent]="ShopTileComponent$"
      (click)="onShopClick(shop, i)"
      (keydown.enter)="onShopClick(shop, i)"
      tabindex="-1"
      class="hoverable shop-tile-container"
      [props]="{
        shop,
        onRouterClick: this.onRouterClick.bind(this)
      }"
    ></div>
  }
</div>
<div *ngIf="hasDivider" class="box-divider"></div>
